import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Radio, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import axios from 'axios';
import "./Form.css";
import { register } from "numeral";

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class GradesTipoForm extends Component {
  state = {
    registro: {
      gtp_idf: 0,
      gtp_descricao: '',
      gtpt_tipo: { key: '0' }
    },

    gradeSelect: [],
    listaGrades: [],
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        listaGrades: this.props.registroSelecionado.listaGrades
      }, () => {
        // this.refs.gtam_descricao.focus();
      });

      this.buscaGrades()
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };


  onOK = () => {
    if ((!this.state.registro.gtp_descricao) || (this.state.registro.gtp_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    const reg = {
      gtp_idf: this.state.registro.gtp_idf,
      gtp_descricao: this.state.registro.gtp_descricao,
      listaGrades: this.state.listaGrades,
    }
    this.props.onSalvarClick(reg);
  };



  onOKGrade = () => {
    if ((!this.state.gtp_idf) || (this.state.gtp_idf.key === '0') || (this.state.gtp_idf.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tamanho', });
      return;
    }

    this.state.listaGrades.push({
      gtpt_tipo: parseInt(this.props.registroSelecionado.dados.gtp_idf.key),
      gtpt_tamanho: parseInt(this.state.gtpt_tipo.key),
      gtam_descricao: this.state.gtpt_tipo.label,
    });

    this.setState({
      listaGrades: this.state.listaGrades
    });
  };


  onExcluirClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir esta Grade?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaGrades = [...this.state.listaGrades];
        const index = listaGrades.findIndex(registro => registro.gtpt_tipo === reg.gtpt_tipo);
        listaGrades.splice(index, 1);
        this.setState({
          listaGrades,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirClick(registro)} icon="delete" />
      </Tooltip>
    );
  };


  buscaGrades = (value) => {
    this.setState({ gradeSelect: [] })
    const { gtp_idf } = this.state.registro;
    axios.get('/gradesTamanho/lista', {
    }).then(response => {
      const { data } = response;
      const gradeSelect = data.map(regList => {
        return {
          key: regList.gtam_idf,
          label: regList.gtam_descricao
        }
      });

      let grade = gtp_idf;
      if (!gtp_idf) {
        grade = gradeSelect[0].key;
      }

      this.setState({
        gradeSelect,
        gtp_idf: grade,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }







  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { gtp_idf, gtp_descricao, gtpt_tipo } = this.state.registro;
    const { listaGrades, gradeSelect } = this.state;

    // console.log('GradesTipoForm', this.props)
    // console.log('GradesTipoForm', this.state)

    return (
      <Modal
        title={gtp_idf ? "Edição de Tipo de Grade" : "Cadastro de Tipo de Grade"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"30%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição</span>
              <InputForm
                id="gtp_descricao"
                ref="gtp_descricao"
                maxLength={15}
                onChange={this.onChange}
                value={gtp_descricao}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>


          <Row>
            <Col xs={24} sm={8} style={{ marginTop: 10, paddingRight: 15 }}>
              <span>Tamanho</span>
              <InputForm
                type="select"
                id="gtpt_tipo"
                ref="gtpt_tipo"
                value={gtpt_tipo}
                placeholder="Selecione"
                onChange={this.onChange}
                data={gradeSelect}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                showSearch
              />
            </Col>
            <Col xs={24} sm={8} style={{ marginTop: 28 }}>
              <Button
                htmlType="button"
                onClick={this.onOKGrade}
                icon="plus"
                className="botoesModalForm2x"
              > Adicionar
              </Button>
            </Col>
          </Row>

          <Row>
            <Col xs={24}>
              <Table
                dataSource={listaGrades}
                pagination={false}
                rowKey={(listaGrades => listaGrades.gtpt_tamanho)}
              >
                <Column
                  key="gtam_descricao"
                  dataIndex="gtam_descricao"
                  title="Tamanho"
                  width={"40%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="acoes"
                  title=""
                  render={this.renderAcoesProdutos}
                  width={"30%"}
                  align="right"
                  className="listaCadastro"
                />
              </Table>
            </Col>
          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GradesTipoForm.js